import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import { VerifyPaymentIcon } from '../FullPageErrorFallback/assets';
import { Wrapper, Header, Container, Img, Title, Description, Supporter } from './index.view';

const PaymentEmailVerify = () => {
  const { t } = useTranslation();
  const contactEmail = () => <Supporter href="mailto:support@fanz.io">support@fanz.io.</Supporter>;
  return (
    <Wrapper>
      <Header>
        <Icon name="logo" />
      </Header>
      <Container maxWidth="md">
        <Img src={VerifyPaymentIcon} alt="verify-your-payment" />

        <Title>{t('verifyYourPaymentTitle')}</Title>

        <Description>
          {t('verifyYourPaymentDesc')}
          {contactEmail()}
        </Description>
      </Container>
    </Wrapper>
  );
};

export default PaymentEmailVerify;
